export const articles = [
  {
    id: "pa-time",
    type: "analysis",
    title: "《蜜桃成熟时1997》里的“时间”到底走得多慢",
    excerpt:
      "为什么同一段感情要拍三遍？我们从三段式结构出发，拆解导演如何用重复与留白，让“错过”变成一种可以被反复咀嚼的情绪。",
    date: "2026-09-28",
    tag: "深度解析",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20analytical%20collage%20of%20old%20clock%20faces%20and%201990s%20Hong%20Kong%20street%20photos%2C%20peach%20and%20cream%20palette%2C%20soft%20grain%20texture%2C%20editorial%20article%20visual&width=800&height=500&seq=art-pa-time&orientation=landscape",
    content:
      "很多人第一次看《蜜桃成熟时1997》，会觉得它讲的是一个很简单的爱情故事：两个人相遇、靠近、错过。但当你再看第二遍，会发现真正的主角其实是时间。影片刻意把同一段关系拆成三个时间切片，每一切片都在讨论一个不同的命题——相遇时的可能性、错位时的无力感，以及多年之后的和解。\n\n第一幕用大量明亮的自然光与轻松的配乐，制造出一种“未来还很辽阔”的错觉。到了第二幕，色调骤然转冷，雨夜与空荡的走廊反复出现，人物的距离感被镜头语言直接放大。第三幕则回到暖色，但那种暖已经不再是热烈，而是一种被时间过滤后的平静。\n\n导演最聪明的地方在于留白。他不告诉我们那几年里发生了什么，只让我们看到人物重新坐到一起时的表情。正是这些空白，让观众把自己的人生经验填了进去，于是同一部电影，每个人看到的都是不同的遗憾。",
  },
  {
    id: "pa-peach",
    type: "analysis",
    title: "一颗蜜桃的三种含义：从符号到记忆",
    excerpt:
      "那颗反复出现的蜜桃不只是情欲的暗示。它如何被导演一层层剥开，最终变成关于“珍藏”的隐喻？",
    date: "2026-09-21",
    tag: "符号解读",
    cover:
      "https://readdy.ai/api/search-image?query=artistic%20still%20life%20of%20ripe%20peaches%20on%20a%20weathered%20wooden%20table%2C%20warm%20peach%20and%20cream%20tones%2C%20soft%20window%20light%2C%20nostalgic%20editorial%20mood&width=800&height=500&seq=art-pa-peach&orientation=landscape",
    content:
      "在《蜜桃成熟时1997》中，蜜桃出现了七次。第一次它是随手买来的水果，第二次它出现在女主角的办公桌上，第三次它被切开……如果只把它当作情欲的符号，那就低估了导演的野心。\n\n随着剧情推进，蜜桃逐渐脱离了它原本的含义。它变成了一个约定，一个只能被某个人认出的暗号。到最后一次出现时，它已经和人物之间的承诺捆绑在一起——看见蜜桃，就等于看见那段无法复制的时间。\n\n这就是符号的力量：当一个物件被反复赋予情绪，它就不再是它本身，而成为一个可以随身携带的记忆容器。",
  },
  {
    id: "pa-hk-film",
    type: "analysis",
    title: "九十年代港片的“都市孤独”从何而来",
    excerpt:
      "把《蜜桃成熟时1997》放回九十年代香港电影的大背景下，你会发现那道霓虹里的孤独，是一整代人的共同情绪。",
    date: "2026-09-14",
    tag: "影史脉络",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%201990s%20Hong%20Kong%20neon%20street%20at%20night%20from%20above%2C%20warm%20amber%20and%20deep%20teal%20contrast%2C%20rainy%20reflections%2C%20cinematic%20editorial%20texture&width=800&height=500&seq=art-pa-hkfilm&orientation=landscape",
    content:
      "九十年代的香港电影，似乎特别擅长拍孤独。无论是便利店里数着过期罐头的人，还是深夜街头擦肩而过的陌生人，都在同一座喧嚣的城市里保持着一种得体的疏离。\n\n《蜜桃成熟时1997》延续了这一传统，却把它处理得更温柔。它不强调城市的冷漠，而是让城市成为情感的背景板：霓虹是心跳，雨夜是眼泪，渡轮是告别。\n\n理解这种孤独，需要回到那个特定的年代。急速变化的城市、流动的人口、对未来的不确定，共同塑造了一代人既渴望亲密又害怕靠近的复杂心态。电影只是把这种心态，翻译成了可以被观看的影像。",
  },
  {
    id: "pa-rain",
    type: "analysis",
    title: "雨夜、天台与渡轮：三组视觉母题的对照",
    excerpt:
      "为什么重要的对话总发生在下雨的时候？我们逐一对照影片中的三组场景母题，看它们如何推动情绪。",
    date: "2026-09-07",
    tag: "视听语言",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20rainy%20rooftop%20scene%20at%20dusk%20with%20city%20lights%2C%20warm%20against%20cool%20blue%20tones%2C%20atmospheric%20mood%20editorial%20visual&width=800&height=500&seq=art-pa-rain&orientation=landscape",
    content:
      "如果要给《蜜桃成熟时1997》选三个关键词，我会选：雨夜、天台、渡轮。这三组母题几乎承包了全片所有重要时刻。\n\n雨夜代表的是“无法逃避的相遇”。在雨里，人们无处可去，只能面对彼此。天台则相反，它是“可以暂时躲开世界的地方”，所有不敢说的话，都在风里被轻轻说出。而渡轮，是“必然的告别”——它总是驶向对岸，从不回头。\n\n三组母题交替出现，形成一种呼吸般的节奏：相遇、喘息、告别，再相遇。导演没有用台词去解释它们，却让观众在不知不觉中，被这种节奏牵着走。",
  },
  {
    id: "pa-music",
    type: "analysis",
    title: "配乐如何替人物说出那些说不出口的话",
    excerpt:
      "当对白沉默时，音乐接管了叙事。本片配乐的三条线索，值得单独拿出来听一遍。",
    date: "2026-08-30",
    tag: "声音设计",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20cassette%20player%20and%20headphones%20on%20a%20warm%20wooden%20desk%2C%20peach%20and%20amber%20tones%2C%20soft%20window%20light%2C%20nostalgic%20editorial%20still%20life&width=800&height=500&seq=art-pa-music&orientation=landscape",
    content:
      "《蜜桃成熟时1997》的台词其实并不多，很多情绪是靠音乐完成的。配乐大致有三条线索：明亮的口琴主题、低沉的大提琴线条，以及一首反复出现的旧歌。\n\n口琴主题几乎只在两人相处融洽时出现，它是“当下”的声音；大提琴则总在人物独处时响起，代表“回忆”的重量。而那首旧歌，更像一条隐线，每次出现都在提醒观众：时间在走，人也在变。\n\n当你关闭画面只听声音，会发现整个故事的轮廓依然清晰。这正是好的电影音乐的标准——它不是装饰，而是叙事的一部分。",
  },
  {
    id: "pa-ending",
    type: "analysis",
    title: "渡轮离港的长镜头，究竟想说什么",
    excerpt:
      "结尾那个看似平淡的长镜头，其实藏了导演对整部电影最想说的话。我们试着把它读出来。",
    date: "2026-08-24",
    tag: "结尾解读",
    cover:
      "https://readdy.ai/api/search-image?query=ferry%20leaving%20a%20harbour%20at%20sunset%20viewed%20from%20shore%2C%20warm%20peach%20and%20amber%20sky%2C%20calm%20sea%2C%20melancholic%20cinematic%20editorial%20mood&width=800&height=500&seq=art-pa-ending&orientation=landscape",
    content:
      "很多人觉得《蜜桃成熟时1997》的结尾太淡了：一艘渡轮慢慢离港，镜头停了几十秒，然后黑场。但正是这个“淡”，构成了全片最有力的收束。\n\n导演没有安排重逢，也没有安排彻底的分手，而是选择了“离开”这个动作本身。渡轮驶向对岸，意味着一段关系告一段落，但生活仍在继续。镜头之所以停留这么久，是想让观众和人物一起，把这段时间好好告别。\n\n好的结尾不是给你答案，而是给你一个可以带着走的心情。当你走出影院，听见城市的汽笛声，或许就会想起那个长镜头——这就是它的余韵。",
  },
  {
    id: "guide-first",
    type: "guide",
    title: "第一次看九十年代港片？这份入门清单请收好",
    excerpt:
      "不知道怎么开始？我们从人物、节奏与题材三条线，给你一份不踩雷的入门观影顺序。",
    date: "2026-09-25",
    tag: "观影建议",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20home%20movie%20night%20setup%20with%20vintage%20tv%20and%20warm%20lamp%20light%2C%20peach%20and%20cream%20tones%2C%20blanket%20on%20sofa%2C%20nostalgic%20editorial%20mood&width=800&height=500&seq=guide-first&orientation=landscape",
    content:
      "如果你刚刚对九十年代港片产生兴趣，很容易被海量的片单淹没。其实入门不需要看“最经典”的那几部，而应该按照自己的节奏来。\n\n第一条线是人物。先从角色好记、情感直白的作品开始，让自己习惯那种略带夸张的表演节奏。第二条线是节奏，九十年代港片普遍偏快，可以挑一些时长在 95 分钟以内的作品。第三条线是题材，爱情、喜剧、动作三选一，先找到让你舒服的方向。\n\n看片时不必追求“看懂”。那个年代的很多魅力来自氛围，而不是剧情。允许自己走神，允许自己被某一帧画面打动，这才是最舒服的观看方式。",
  },
  {
    id: "guide-history",
    type: "guide",
    title: "背景补充：九十年代亚洲电影的黄金十年",
    excerpt:
      "理解一部电影，往往需要先理解它诞生的年代。我们梳理九十年代亚洲电影的关键脉络。",
    date: "2026-09-18",
    tag: "影视史",
    cover:
      "https://readdy.ai/api/search-image?query=archival%20flat%20lay%20of%20old%20film%20reels%2C%20photographs%20and%20ticket%20stubs%20on%20warm%20paper%2C%20sepia%20and%20peach%20tones%2C%20editorial%20history%20mood&width=800&height=500&seq=guide-history&orientation=landscape",
    content:
      "九十年代是亚洲电影极为特殊的一段时期。城市在快速变化，观众的口味也在变化，创作者们得以在商业与艺术之间寻找新的平衡。\n\n这一时期诞生了大量至今仍被反复讨论的作品：既有面向大众的类型片，也有极具个人风格的作者电影。它们共享着相似的情绪底色——对身份的追问、对亲密关系的渴望，以及对时间流逝的敏感。\n\n把这些电影放回它们诞生的年代去看，你会发现很多当时被视为“花哨”的手法和风格，其实都是创作者对时代最直接的回应。",
  },
  {
    id: "guide-culture",
    type: "guide",
    title: "电影文化漫谈：为什么老电影越看越有味道",
    excerpt:
      "画质不如今天，特效更是朴素，为什么那些老片反而让人念念不忘？聊聊影像之外的“味道”。",
    date: "2026-09-11",
    tag: "电影文化",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20film%20projector%20beam%20in%20a%20dim%20warm%20room%2C%20dust%20motes%20in%20light%2C%20amber%20and%20brown%20tones%2C%20nostalgic%20editorial%20mood&width=800&height=500&seq=guide-culture&orientation=landscape",
    content:
      "老电影的味道，很大程度上来自它的“不完美”。画面里的颗粒、偶尔的失焦、不那么精确的转场，反而让影像更接近记忆的质地。\n\n另一个原因是留白。受限于技术和时长，老电影往往把很多信息交给观众去补全。你越是参与其中，情感联结就越深。今天的电影信息量更大，却未必更容易被记住。\n\n所以看老电影，不妨放慢一点。允许那些安静的长镜头多停留几秒，你会发现，味道就藏在这些“多余”的时间里。",
  },
  {
    id: "guide-rewatch",
    type: "guide",
    title: "二刷指南：那些第一次没注意到的细节",
    excerpt:
      "第一次看剧情，第二次看细节。整理了几个二刷时值得盯住的小地方。",
    date: "2026-09-04",
    tag: "观影建议",
    cover:
      "https://readdy.ai/api/search-image?query=hands%20holding%20a%20film%20ticket%20in%20warm%20soft%20light%2C%20peach%20and%20cream%20tones%2C%20shallow%20depth%20of%20field%2C%20nostalgic%20editorial%20still%20life&width=800&height=500&seq=guide-rewatch&orientation=landscape",
    content:
      "好电影值得二刷，而二刷的乐趣，全在细节里。\n\n第一处，注意人物衣服的颜色变化。它往往对应着角色情绪的高潮与低谷。第二处，留意背景里的电视和广播，它们常常在悄悄交代时间点。第三处，盯住那些不起眼的道具，比如一只杯子、一张车票，它们会在后面的情节里再次出现。\n\n把这些细节连起来看，你会发现导演其实比你以为的更“啰嗦”，只是他把话说在了画面里，而不是台词里。",
  },
  {
    id: "guide-collection",
    type: "guide",
    title: "如何收藏一部电影：从碟片到数字时代的仪式感",
    excerpt:
      "喜欢一部电影，除了重看，还能怎么珍藏它？聊聊收藏这件事本身的仪式感。",
    date: "2026-08-27",
    tag: "电影文化",
    cover:
      "https://readdy.ai/api/search-image?query=shelf%20of%20vintage%20film%20posters%20and%20collectible%20items%20in%20warm%20study%2C%20amber%20and%20cream%20tones%2C%20soft%20lamp%20light%2C%20nostalgic%20editorial%20mood&width=800&height=500&seq=guide-collection&orientation=landscape",
    content:
      "收藏一部电影的方式有很多种：一张海报、一张原声碟、一个反复观看的播放列表，或者只是把它记在心里。\n\n重要的不是形式，而是那种“它属于我”的感觉。当你为自己的收藏排好序、贴好标签，你就为一段记忆找到了一个家。\n\n在这个数字时代，我们其实更容易收藏，也更容易遗忘。所以不妨给自己一点仪式感：为喜欢的东西建一个清单，定期回看它。收藏的意义，就在于提醒你曾经被什么打动过。",
  },
  {
    id: "news-restore",
    type: "news",
    title: "经典港片修复计划公布新一轮名单",
    excerpt:
      "多家机构联合宣布，将对一批九十年代经典作品进行 4K 修复，让老电影以更清晰的面貌重回观众视野。",
    date: "2026-09-30",
    tag: "影视资讯",
    cover:
      "https://readdy.ai/api/search-image?query=film%20restoration%20workspace%20with%20reels%20and%20scanning%20equipment%2C%20warm%20amber%20lighting%2C%20technical%20yet%20nostalgic%20editorial%20mood&width=800&height=500&seq=news-restore&orientation=landscape",
    content:
      "新一轮经典港片修复计划近日公布名单，多部九十年代的代表性作品位列其中。项目方表示，修复工作不仅包括画面扫描与调色，也会对原始音轨进行重新整理，力求在提升清晰度的同时保留胶片原有的质感。\n\n业内认为，修复不仅是技术工作，也是一次对电影史的重新梳理。让年轻观众有机会在大银幕上看到这些作品，本身就是一种文化传承。",
  },
  {
    id: "news-festival",
    type: "news",
    title: "亚洲经典电影回顾展将于下月开幕",
    excerpt:
      "为期两周的回顾展将集中放映数十部九十年代亚洲电影，并配套举办多场映后谈与主题讲座。",
    date: "2026-09-23",
    tag: "影视资讯",
    cover:
      "https://readdy.ai/api/search-image?query=classic%20cinema%20auditorium%20with%20warm%20seats%20and%20screen%20glow%2C%20amber%20and%20cream%20tones%2C%20nostalgic%20editorial%20mood&width=800&height=500&seq=news-festival&orientation=landscape",
    content:
      "一场聚焦亚洲经典电影的回顾展将于下月开幕，展期两周。主办方表示，此次放映的片单经过精心编排，既有广为人知的代表作，也有长期被忽视的冷门佳作。\n\n除放映外，活动还安排了映后谈与主题讲座，邀请研究者与观众一起，重新理解这些作品在今天的意义。门票将于本周开启预约。",
  },
  {
    id: "news-book",
    type: "news",
    title: "新书聚焦九十年代香港电影的城市书写",
    excerpt:
      "一本以九十年代香港电影为主题的新书近日出版，从城市空间的角度重新审视那个黄金年代。",
    date: "2026-09-16",
    tag: "影视资讯",
    cover:
      "https://readdy.ai/api/search-image?query=open%20book%20about%20cinema%20on%20a%20warm%20wooden%20desk%20with%20coffee%2C%20peach%20and%20cream%20tones%2C%20soft%20window%20light%2C%20editorial%20still%20life&width=800&height=500&seq=news-book&orientation=landscape",
    content:
      "新书《霓虹与街巷》近日出版，作者以九十年代香港电影中的城市空间为切入点，讨论霓虹、天台、码头等意象如何参与叙事。\n\n作者在书中提出，那个年代的电影之所以令人怀念，不仅因为故事本身，更因为它们记录了一座城市正在消失的样子。书中配有大量剧照与实地照片，兼具可读性与资料价值。",
  },
  {
    id: "news-streaming",
    type: "news",
    title: "流媒体上线经典专区，老片观看更便利",
    excerpt:
      "多家平台新增经典电影专区，用户可免费或以较低成本观看一批九十年代作品。",
    date: "2026-09-09",
    tag: "影视资讯",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20tv%20screen%20showing%20a%20grid%20of%20classic%20film%20posters%20in%20a%20warm%20living%20room%2C%20amber%20tones%2C%20cozy%20evening%20light%2C%20editorial%20mood&width=800&height=500&seq=news-streaming&orientation=landscape",
    content:
      "为了让更多观众接触经典电影，多家流媒体平台近期上线了经典专区，集中收录一批九十年代的亚洲电影。专区按要求对影片进行了清晰度优化，并补充了简介与创作背景资料。\n\n平台方表示，未来还会定期更新片单，并根据观看数据调整推荐策略，让好电影更容易被找到。",
  },
  {
    id: "news-award",
    type: "news",
    title: "回顾展映后谈实录：我们为什么还在谈论九十年代",
    excerpt:
      "在上周举行的一场映后谈中，几位研究者围绕“九十年代为何持续吸引今天的观众”展开了讨论。",
    date: "2026-09-02",
    tag: "影视资讯",
    cover:
      "https://readdy.ai/api/search-image?query=panel%20discussion%20on%20a%20warmly%20lit%20stage%20with%20microphones%2C%20amber%20and%20cream%20tones%2C%20editorial%20event%20mood&width=800&height=500&seq=news-award&orientation=landscape",
    content:
      "在上周举行的映后谈中，几位研究者围绕“九十年代为何持续吸引今天的观众”各抒己见。有人认为，是因为那个年代的电影敢于谈论情绪；也有人指出，是因为它们为观众保留了足够的想象空间。\n\n讨论最后形成了一个共识：经典之所以成为经典，不是因为它们完美，而是因为它们真诚。这种真诚，恰恰是跨越年代依然有效的。",
  },
];